import {
  Events,
  IStatusPanelComp,
  IStatusPanelParams,
} from '@ag-grid-community/core'
import { loadTemplate } from '@ag-grid-community/core/dist/cjs/utils/dom'

const template = `
  <span class="hs-status-bar hs-total-rows-status-bar">
    <span>Loaded rows:</span> <span class="value ml-1">0</span>
  </span>
`

/**
 * `Loaded rows: <displayed>` for the workbench grids.
 *
 * The label is qualified deliberately. On the server-side row model this counts the rows currently in
 * the grid's block cache, which is a rolling window over the result set (see the grid's
 * MAX_BLOCKS_IN_CACHE) rather than the whole of it — the response carries no total, so there is no
 * honest unqualified figure to print. An unqualified "Rows: 5000" against an account of 40,000 is a
 * wrong answer that looks like a right one; the money / units / unit-difference panels sum the same
 * window and carry the same caveat.
 *
 * Uses the same markup as the server-side counterpart in `@helios/generic-components` so the two
 * render identically wherever they appear.
 */
export class WorkbenchRowsStatusBarComp implements IStatusPanelComp {
  private readonly eGui = loadTemplate(template)

  private params?: IStatusPanelParams

  /** @internal */
  readonly modelUpdatedListener = () => this.refresh()

  init(params: IStatusPanelParams): void {
    this.params = params
    params.api.addEventListener(
      Events.EVENT_MODEL_UPDATED,
      this.modelUpdatedListener,
    )
    this.refresh()
  }

  destroy(): void {
    this.params?.api.removeEventListener(
      Events.EVENT_MODEL_UPDATED,
      this.modelUpdatedListener,
    )
  }

  getGui(): HTMLElement {
    return this.eGui
  }

  /** @internal */
  refresh(): void {
    const value = this.eGui.querySelector('.value')
    if (value != null) {
      value.textContent = `${this.params?.api.getDisplayedRowCount() ?? 0}`
    }
  }
}
